module.exports = __webpack_public_path__ + "static/media/oznamko.1ea4eb85.png";